const userStorage = {
  state:{
    userInfo:localStorage.getItem('userInfo') || null,
    localizationSetting:localStorage.getItem('localization') || null,
    timeFormat:[
      {
        id:1,
        value:'12 Hrs'
      },
      {
        id:2,
        value:'24 Hrs'
      }
    ],
    dateFormat:[
      {
        id:1,
        value:'DD/MM/YY',
        key_val:'d/m/y'
        
      },
      {
        id:2,
        value:'DD/MM/YYYY',
        key_val:'d/m/Y'
        
      },
      {
        id:3,
        value:'MM/DD/YY',
        key_val:'m/d/y'
        
      },
      {
        id:4,
        value:'MM/DD/YYYY',
        key_val:'m/d/Y'
        
      },
      {
        id:5,
        value:'YYYY/MM/DD',
        key_val:'Y/m/d'
        
      },
      {
        id:6,
        value:'YYYY/DD/MM',
        key_val:'Y/d/m'
        
      }
    ],
  },
  mutations: {
    SET_USER_INFO_MUTATION:(state, payload) => {
      state.userInfo = JSON.stringify(payload)
    },
    SET_LOCALIZATION_MUTATION:(state, payload) => {
      state.localizationSetting = JSON.stringify(payload)
    }

  },
  actions:{
    SET_USER_INFO:({commit}, payload) => {
      commit('SET_USER_INFO_MUTATION', payload)
    },
    SET_LOCALIZATION:({commit}, payload) => {
      commit('SET_LOCALIZATION_MUTATION', payload)

    }
  },
  getters: {
    get_userinfo_data (state) {
      return JSON.parse(state.userInfo)
    },
    get_localization_setting (state) {
    
      try {
        return JSON.parse(state.localizationSetting)
      } catch (err) {
        return null
      }
    },
    get_data_format_option (state) {
      return state.dateFormat
    },
    get_time_format_option (state) {
      return state.timeFormat
    }
  }
}

export default userStorage

